import { render, staticRenderFns } from "./label-setting.vue?vue&type=template&id=42a1ca95&scoped=true&"
import script from "./label-setting.vue?vue&type=script&lang=js&"
export * from "./label-setting.vue?vue&type=script&lang=js&"
import style0 from "./label-setting.vue?vue&type=style&index=0&id=42a1ca95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a1ca95",
  null
  
)

export default component.exports